export default __webpack_public_path__ + "static/13-8b6e66fa9a36561f654ccd4535cba301.jpg";